import { Typography, Box, useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';

// Component for Variables content
const APIDocumentationOverview = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box style={{
            display: 'flex', flexDirection: 'column', gap: '16px', flex: 1, overflowY: 'auto',
            p: 3
        }}>

            <Typography
                variant="body1"
                style={{ width: isMediumScreen ? '100%' : '60%' }}
            >
                <strong>Document Your APIs in HawkClient</strong>
                <br />
                <br />
                <p>
                    HawkClient makes it easy to keep your APIs well-documented by supporting <strong>Markdown-based documentation</strong> at both the <strong>collection</strong> and <strong>request</strong> levels.
                </p>

                <ul style={{ paddingLeft: '20px' }}>
                    <li>
                        <strong>Collection-Level Documentation</strong> – Click the <em>Manage</em> option from the collection dropdown to access the <strong>Overview</strong> tab. On the left, you can write rich Markdown documentation for the entire collection. On the right, you’ll see workspace and file location details for quick context.
                    </li>
                    <li>
                        <strong>Request-Level Documentation</strong> – Open any request and navigate to the <strong>Docs</strong> tab to describe request-specific details such as purpose, parameters, headers, expected responses, and any other helpful notes—all using Markdown.
                    </li>
                </ul>

                <p>
                    With Markdown support built-in, HawkClient lets you maintain clear and collaborative API documentation directly within your workspace.
                </p>
            </Typography>
        </Box>
    )
};

export default APIDocumentationOverview;